<div class="creative-card-grid">
  @for (card of cards; track card) {
    <app-creative-card [card]="card" (cardClicked)="cardClicked.emit($event)"></app-creative-card>
  }
</div>
